<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-account size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Account</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby.username }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.acc_name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.acc_name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              <template #cell(members)="data">
                  <div class="btn-group">
                    <router-link :to="{ path: '/accountmembers',  query: { id: data.item.acc_number }}" type="button" class="btn-sm btn btn-dark"> <i class="fas fa-users"></i></router-link>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-account" centered title="New Group Account" title-class="font-18" hide-footer>
        <form @submit.prevent="addItem">
            <div class="form-group mb-2">
            <label>Account Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-account')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-account" centered title="Edit Group Account" title-class="font-14" hide-footer>
        <form @submit.prevent="editItem">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Account Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-account')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-account" centered title="Delete Group Account" title-class="font-18" hide-footer>
        <form @submit.prevent="removeItem">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Account : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-account')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { groupaccountMethods, groupaccountComputed } from "@/state/helpers";

export default {
  page: {
    title: "Group Accounts",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      title: "Group Accounts",
      items: [ {text: "Dashboard",to: "/",}, {text: "Group Accounts",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'acc_name', label: 'Acc Name', visible: true },
          { key: 'acc_number', label: 'Acc Number', visible: true },
          { key: 'members', label: 'Members', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
      category:'',
    };
  },
  computed: {
    ...groupaccountComputed,
    List() { return this.groupaccounts.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.groupaccounts.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.groupaccounts.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchGroupAccounts();
    this.TotalRows = this.groupaccounts.length;
    this.isBusy=false;
  },
  methods: {
    ...groupaccountMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('edit-account')
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-account')
    },
    async addItem() { 
      let formData = new FormData();
      formData.append("name", this.name);
      let url = "/addgroupaccount";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchGroupAccounts();
          this.$bvModal.hide('new-account');
          this.name="";
        }
      });
    },
    async editItem(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("name", this.name);
    let url = "/updategroupaccount";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchGroupAccounts();
        this.$bvModal.hide('edit-account');
        this.name="";
      }
    });
    },
    async removeItem() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removegroupaccount";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchGroupAccounts();
        this.$bvModal.hide('delete-account');
      }
    });
    },
  },
};
</script>